import React from "react";
import {
  Box,
  Flex,
  Link,
  TabList,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import LandingPageTabs from "@/features/landing/components/common/Tabs";
import FeatureSectionContainer from "@/features/landing/components/common/FeatureSectionContainer";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { Trans } from "react-i18next";

interface Props {
  isSignedIn: boolean;
}

const tabLabels = [
  "market.tab_brand_ranking",
  "market.tab_markup_trend",
  "market.tab_product_ranking",
];

const tabPanels = [
  {
    src: "/images/landing-market-dash-brand.webp",
    alt: "screen example of market dashboard brand ranking",
  },
  {
    src: "/images/landing-market-dash-markup.webp",
    alt: "screen example of market dashboard markup trend chart",
  },
  {
    src: "/images/landing-market-dash-ranking.webp",
    alt: "screen example of market dashboard product ranking",
  },
];

function LandingPageMarketDashboardSection({ isSignedIn }: Props) {
  const [tabIndex, setTabIndex] = React.useState(0);
  const { tTitle, tSentence } = useI18nHelper();

  return (
    <Flex
      as={"section"}
      aria-labelledby={"landing-market-dashboard-title"}
      paddingX={{
        base: "16px",
        lg: "24px",
      }}
    >
      <FeatureSectionContainer maxWidth={"1318px"} margin={"0 auto"}>
        <Flex
          flexDirection={"column"}
          gap={{
            base: "12px",
            lg: "24px",
          }}
          flex={1}
          alignItems={{
            base: "center",
            md: "flex-start",
          }}
        >
          <Text
            color={"#1272EF"}
            fontSize={{
              base: "16px",
              lg: "24px",
            }}
            fontWeight={700}
            lineHeight={{
              base: "24px",
              lg: "32px",
            }}
            as={"h2"}
            id={"landing-market-dashboard-title"}
          >
            {tTitle("landing:market.title")}
          </Text>
          <Flex
            flexDirection={"column"}
            fontSize={{
              base: "28px",
              lg: "48px",
            }}
            fontWeight={700}
            textAlign={{
              base: "center",
              md: "start",
            }}
            lineHeight={{
              base: "38px",
              lg: "68px",
            }}
          >
            <Trans
              i18nKey={"landing:market.subtitle"}
              components={{
                br: <Box as={"span"} />,
              }}
            />
          </Flex>
          <Text
            fontSize={{
              base: "16px",
              lg: "24px",
            }}
            lineHeight={{
              base: "24px",
              lg: "32px",
            }}
            color={"#737373"}
            textAlign={{
              base: "center",
              md: "start",
            }}
          >
            <Trans
              i18nKey={"landing:market.description"}
              components={{
                br: <Box as={"span"} display={{ base: "none", md: "block" }} />,
              }}
            />
            {/*<Box*/}
            {/*  as={"span"}*/}
            {/*  display={{*/}
            {/*    base: "inline",*/}
            {/*    md: "block",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  지금 사야 할 상품을 빠르게 판단할 수 있도록{" "}*/}
            {/*</Box>*/}
            {/*<Box*/}
            {/*  as={"span"}*/}
            {/*  display={{*/}
            {/*    base: "inline",*/}
            {/*    md: "block",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  브랜드별 리테일 시장의 인사이트를 제공합니다.*/}
            {/*</Box>*/}
          </Text>
        </Flex>
        <Flex flex={1}>
          <LandingPageTabs
            labels={tabLabels}
            index={tabIndex}
            onChange={(index) => {
              setTabIndex(index);
            }}
            panels={tabPanels}
          />
        </Flex>
      </FeatureSectionContainer>
    </Flex>
  );
}

export default LandingPageMarketDashboardSection;
